import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TramoService } from 'src/app/services/tramo.service';
import { Subscription, Observable } from 'rxjs';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { TramoLicitacion } from 'src/app/models/entities/tramo-licitacion';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';

@Component({
  selector: 'admon-tramo-licitacion',
  templateUrl: './admon-tramo-licitacion.component.html',
  styleUrls: ['./admon-tramo-licitacion.component.scss']
})
export class AdmonTramoLicitacionComponent implements OnInit {

  @ViewChild('modalConfirmacion')
  public modal: any;
  public modalActivo: NgbModalRef;
  public registroSeleccionado: any;
  public tramosLicitaciones$: Observable<TramoLicitacion[]>;
  public tramosLicitaciones: TramoLicitacion[] = [];
  public keyObra: string = '';
  public empresas: any[] = [];
  public suscripcionCatEmpresas: Subscription;
  public cols: any[] = [
    { field: 'key', header: 'Key' },
    { field: 'descripcionContrato', header: 'Descripción' },
    { field: 'empresa', header: 'Empresa' },
    { field: 'montoAnticipo', header: 'Monto con IVA' },
    { field: 'avanceFisicoProgramado', header: 'Avance Físico %' },
    { field: 'avanceFinancieroProgramado', header: 'Avance Financiero %' }
  ];

  public constructor(
    private activatedRoute: ActivatedRoute,
    private ngbModalService: NgbModal,
    private catalogoService: CatalogoService,
    private tramoLicitacionService: TramoService
  ) { }

  public ngOnInit() {
    this.keyObra = this.activatedRoute.snapshot.params.keyObra;
    this.obtenerCatEmpresas();
    this.tramosLicitaciones$ = this.tramoLicitacionService.findByKeyObra(this.keyObra);
    this.tramosLicitaciones$.subscribe(tramosLicitacion => this.tramosLicitaciones = tramosLicitacion);
  }

  public obtenerCatEmpresas(): void {
    this.suscripcionCatEmpresas = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.EMPRESAS).pipe(take(1)).subscribe(
      (empresas: ElementoCatalogo[]) => {
        this.empresas = empresas;
      }
    );
  }

  public buscarNombreEmpresa(dato: any) {
    return this.empresas.find(e => e.key.toString() === dato).nombre;
  }

  public confirmarEliminacion(tramoLicitacion: TramoLicitacion): void {
    this.registroSeleccionado = tramoLicitacion;
    this.modalActivo = this.ngbModalService.open(this.modal, { centered: true, windowClass: 'modal-eliminacion' });
  }

  public eliminar(): void {
    this.tramoLicitacionService.remove(this.registroSeleccionado.key)
      .catch(
        (error) => {
          console.error("Error al borrar registro.", error);
        }
      ).finally(
        () => {
          this.tramosLicitaciones = this.tramosLicitaciones.filter((tramos: TramoLicitacion) => tramos.key !== this.registroSeleccionado.key);
          this.cerrarModal();
        }
      )
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public ngOnDestroy(): void {
    if (this.suscripcionCatEmpresas) {
      this.suscripcionCatEmpresas.unsubscribe();
    }
  }

}